import * as React from 'react';
import {InventoryInfo, InventoryProperty, Unit} from './ItemMasterInterfaces';
import {getPackagingString, getUppercase} from './UomHelpers';

export interface UomTileProps {
  isShipper: boolean;
  inventoryControlUser: boolean;
  faiReceiveWorkflow: boolean;
  inventoryProp: InventoryProperty;
  inventoryInfo: InventoryInfo;
}

const UomTile: React.FC<UomTileProps> = (props: UomTileProps) => {
  const renderPalletTiHi = () => {
    return (
      <div className="item-master-tile">
        <div className="col">
          <div className="header">
            <b>{getPackagingString(props.inventoryProp.packaging)}</b>
          </div>
          <div className="">
            <div className="measurement-list">
              <MeasurementTile
                unit="Per Layer (Ti)"
                measurement=""
                value={props.inventoryInfo.cartons_per_layer}
                column_size={4}
              />
              <MeasurementTile
                unit="Layers (Hi)"
                measurement=""
                value={props.inventoryInfo.layers_per_pallet}
                column_size={4}
              />
              <MeasurementTile
                unit="Net Cartons"
                measurement=""
                value={props.inventoryInfo.cartons_per_pallet}
                column_size={4}
              />
            </div>
            <div className="row">
              <div className="col-sm-6 tile-line-item">
                <b>Stackable:</b>
              </div>
              <div className="col-sm-6 tile-line-item text-right">{props.inventoryInfo.stackable ? 'Yes' : 'No'}</div>
            </div>
            {!props.isShipper && props.faiReceiveWorkflow && (
              <div className="row">
                <div className="col-sm-6 tile-line-item">
                  <b>Stackable:</b>
                </div>
                <div className="col-sm-6 tile-line-item text-right">{props.inventoryInfo.review_date || 'Unknown'}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
  const renderBasicUomTiles = () => {
    return (
      <div>
        <div className="measurement-list">
          <MeasurementTile
            unit={props.inventoryProp.dimension_unit}
            measurement="Length"
            value={props.inventoryProp.length}
            column_size={3}
          />
          <MeasurementTile
            unit={props.inventoryProp.dimension_unit}
            measurement="Width"
            value={props.inventoryProp.width}
            column_size={3}
          />
          <MeasurementTile
            unit={props.inventoryProp.dimension_unit}
            measurement="Height"
            value={props.inventoryProp.height}
            column_size={3}
          />
          <MeasurementTile
            unit={props.inventoryProp.weight_unit}
            measurement="Length"
            value={props.inventoryProp.weight}
            column_size={3}
          />
        </div>
        {props.inventoryProp.parent && (
          <div className="row">
            <div className="col-sm-6 tile-line-item">
              <b>
                {getPackagingString(props.inventoryProp.packaging)} per {getPackagingString(props.inventoryProp.parent)}
                :
              </b>
            </div>
            <div className="col-sm-6 tile-line-item text-right">{props.inventoryProp.units_per_parent}</div>
          </div>
        )}
        <div className="row">
          <div className="col-sm-6 tile-line-item">
            <b>Shipalone:</b>
          </div>
          <div className="col-sm-6 tile-line-item text-right">{props.inventoryProp.ship_alone ? 'Yes' : 'No'}</div>
        </div>
        <div className="row">
          <div className="col-sm-6 tile-line-item">
            <b>Ship As-Is:</b>
          </div>
          <div className="col-sm-6 tile-line-item text-right">{props.inventoryProp.ship_as_is ? 'Yes' : 'No'}</div>
        </div>
        {!props.isShipper && props.inventoryProp.packaging === 'each' && (
          <div>
            <div className="row">
              <div className="col-sm-6 tile-line-item">
                <b>Serial number capture mode:</b>
              </div>
              <div className="col-sm-6 tile-line-item text-right">{props.inventoryProp.serial_number_capture_mode}</div>
            </div>
            <div className="row">
              <div className="col-sm-6 tile-line-item">
                <b>Serial number patterns:</b>
              </div>
              <div className="col-sm-6 tile-line-item text-right">
                {props.inventoryProp.serial_number_patterns && props.inventoryProp.serial_number_patterns.length > 0
                  ? props.inventoryProp.serial_number_patterns[0]
                  : 'No pattern set'}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
  const renderBasicPalletUom = () => {
    return (
      <div className="item-master-tile">
        <div className="col">
          <div className="header">
            <b>{getPackagingString(props.inventoryProp.packaging)}</b>
          </div>
          <div className="tile-line-item">
            <b>{props.inventoryProp.barcode_type} Barcode:</b> {props.inventoryProp.barcode}
          </div>
          {renderBasicUomTiles()}
        </div>
      </div>
    );
  };

  const renderPalletUomTiles = () => {
    if (props.isShipper || !props.inventoryControlUser) {
      //only ti-hi
      return renderPalletTiHi();
    }
    if (props.inventoryControlUser) {
      if (props.faiReceiveWorkflow) {
        return (
          <div>
            {renderPalletTiHi()}
            {renderBasicPalletUom()}
          </div>
        );
      }
      //basic
      return renderBasicPalletUom();
    }
    return <></>;
  };

  const renderNonPalletUom = () => {
    return (
      <div className="item-master-tile">
        <div className="col">
          <div className="header">
            <b>{getPackagingString(props.inventoryProp.packaging)}</b>
          </div>
          <div className="tile-line-item">
            <b>{props.inventoryProp.barcode_type} Barcode:</b> {props.inventoryProp.barcode}
          </div>
          <div>{renderBasicUomTiles()}</div>
        </div>
      </div>
    );
  };

  return props.inventoryProp.packaging === 'pallet' ? renderPalletUomTiles() : renderNonPalletUom();
};

export interface MeasurementTileProps {
  unit: string | Unit;
  measurement: string;
  value: number;
  column_size: number;
}

const MeasurementTile: React.FC<MeasurementTileProps> = (props: MeasurementTileProps) => {
  return (
    <div className={'col-sm-' + props.column_size + ' measurement-div'}>
      <div className="measurement-tile">
        <div className="measurement">{props.measurement}</div>
        <div className="value">
          <b>{props.value ? props.value.toFixed(1) : '--'}</b>
        </div>
        <div className="unit">{getUppercase(props.unit)}</div>
      </div>
    </div>
  );
};

export default UomTile;
